import React from 'react';
import { Route } from 'react-router-dom';

import RenderMergedProps from './RenderMergedProps/RenderMergedProps';

const propsRoute = ({ component, ...rest }) => {
  return (
    <Route
      {...rest} render={routeProps => {
      return RenderMergedProps(component, routeProps, rest);
    }}
    />
  );
};

export default propsRoute;
